export const ROUTE_PATH = '/purchases-without-scan';
